import * as React from 'react';
import { CaptionTypography } from '@components/atoms';

interface DataTableRecordCountProps {
	children: React.ReactNode;
}

export const DataTableRecordCount: React.FC<DataTableRecordCountProps> = ({ children }) => (
	<div data-aid="data-grid-record-count" className="ml-2">
		<CaptionTypography className="text-tertiary" data-aid="data-table-record-count-string">
			{children}
		</CaptionTypography>
	</div>
);
